import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CompanyContactActions from '../_actions/companyContact';
import { CompanyContact } from '../_models/companyContact';

export interface CompanyContactState extends EntityState<CompanyContact> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<CompanyContact> = createEntityAdapter<CompanyContact>();

const initialState: CompanyContactState = adapter.getInitialState({
  loading: false,
  error: null,
});

const companyContactReducer = createReducer(
  initialState,

  on(CompanyContactActions.loadCompanyContacts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CompanyContactActions.loadCompanyContactsSuccess, (state, { companyContacts }) =>
    adapter.setAll(companyContacts, { ...state, loading: false })
  ),

  on(CompanyContactActions.loadCompanyContactsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CompanyContactActions.addCompanyContactSuccess, (state, { companyContact }) =>
    adapter.addOne(companyContact, state)
  ),

  on(CompanyContactActions.updateCompanyContactSuccess, (state, { companyContact }) =>
    adapter.upsertOne(companyContact, state)
  ),

  on(CompanyContactActions.deleteCompanyContactSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    CompanyContactActions.addCompanyContactFailure,
    CompanyContactActions.updateCompanyContactFailure,
    CompanyContactActions.deleteCompanyContactFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CompanyContactState | undefined, action: Action) {
  return companyContactReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
